export enum MY_ACCOUNT_LINKS {
  MyOrganisation = '/my-account/organisation',
  MyTeams = '/my-account/teams',
  MyAccountDetails = '/my-account/edit-account',
  MySubscription = '/my-account/membership-area',
}

export const LINKS_TO_INDEX = [
  MY_ACCOUNT_LINKS.MyOrganisation,
  MY_ACCOUNT_LINKS.MyTeams,
  MY_ACCOUNT_LINKS.MyAccountDetails,
  MY_ACCOUNT_LINKS.MySubscription,
];

export const getLinksToIndex = (isOwner) => {
  if (isOwner) return LINKS_TO_INDEX;
  return LINKS_TO_INDEX.slice(1);
};

export type SelectOption = {
  value: string;
  label: string;
};

export const ALLOWED_MIME_TYPES = ['image/png', 'image/svg+xml'];
